<template>
  <section id="planes" class="py-5 position-relative bg-white">
    <div class="container">
      <div
        class="row no-gutters pb-4 justify-content-center text-center mx-auto text-center"
      >
        <div class="col-12 col-lg-7">
          <h1 class="text-dark">
            Planes
          </h1>
          <p class="lead mt-3">
            Elige uno de nuestros planes y haz crecer tu negocio con Alliance
          </p>
        </div>
      </div> 
      <div style="overflow: auto">
          <table class="w-100 shadow-sm" style="min-width: 800px;">
              <thead>
                  <tr>
                      <th class="card-header header-table"></th>
                      <th class="card-header header-table"  :class="{ 'favorite': item.favorito }" v-for="item in planes" :key="item.title"> 
                          <h6 class="my-0 fw-normal">{{ item.title }}<i class="ri-star-fill text-warning" v-if="item.favorito"></i></h6>
                          <small class="text-muted my-0">{{ item.subTitle }}</small> 
                      </th> 
                  </tr>
              </thead>
              <tbody>
                 <tr v-for="item in beneficios" :key="item.prop">
                    <td class="header-table-td">
                        {{item.title }}
                    </td>
                     <td class="text-center body-table-td" :class="{ 'favorite ': p.favorito }" v-for="p in planes" :key="p.title"> 
                            <div v-if="item.type === 'number'">{{p[item.prop] }}</div>
                            <div v-else-if="item.type === 'boolean'">
                               <i v-if="p[item.prop] == true" class="ri-checkbox-circle-fill" style="color: #22CB5B"></i>
                               <i v-else class="ri-indeterminate-circle-fill" style="color: #F34242;"></i>
                            </div> 
                            <div v-else-if="item.type === 'price'" >
                                  $ {{ p.precio }}<small class="text-muted">/ mes</small> 
                            </div> 
                            <div v-else>
                              <a
                                class="w-100 btn btn-small"
                                :class="{ 'btn-outline-primary ': !p.favorito, 'btn-primary': p.favorito}" 
                                @click="enviarMensaje(p.title)" 
                                >{{ "Contáctanos" }}</a> 
                            </div>
                      </td> 
                 </tr> 
              </tbody>
          </table> 
      </div>
    </div> 
  </section>
</template>

<script>
  import { email } from "../../../utils/helpers"
  import { phone_pa } from "../../../utils/helpers"
  import { beneficios_pa, planes_pa } from "../../../utils/planes"  

  export default {
    name: "PlansPa",
    components: {},
    data() {
      return {
        email: email,
        planes: [...planes_pa],
        beneficios: [...beneficios_pa]
      };
    },
    created() {},
    mesunted() {},
    methods: {
      enviarMensaje(Plan) {
        const phoneNumber = phone_pa.number; // Reemplaza con el número de WhatsApp (sin signos ni espacios)
        const message = encodeURIComponent(`¡Hola! Me gustaría obtener más información sobre el plan ${Plan}.`); // Tu mensaje personalizado

        const url = `https://wa.me/${phoneNumber}?text=${message}`;
        console.log(url);
        window.open(url, "_blank");
      }
    }
  };
</script>

<style lang="scss" scoped>


    .header-table {
        border:  solid 1px #bdbdbd;
        text-align: center !important;
    }

    .header-table-td {
        border-left:  solid 1px #bdbdbd;
        border-bottom:  solid 1px #bdbdbd;
         padding: 10px;
        font-size: 15x;
    }

    .body-table-td { 
        border:  solid 1px #bdbdbd;
        padding: 10px;
        font-size: 20px;
    }

    .favorite {
        background-color: #0c1c2a!important;
        color: #ffff;
        border-color: #000;
    }


</style>
